import { useAuth } from "@contexts/auth";
import { useMutation } from "@tanstack/react-query";
import Common from "@utilities/common";
import { Formik, Form } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IFormData } from "./types";
import { Button, Input } from "@mantine/core";
import RoutesInstance from "@routes/instances";
import * as Yup from "yup";

const LoginContainer = () => {
    const [initialValues] = useState<IFormData>({
        email: "",
        password: "",
    });
    const [isFirstTime, setIsFirstTime] = useState(true);

    const { actions } = useAuth();

    const navigate = useNavigate();

    const { mutate, isLoading } = useMutation(
        (values: IFormData) =>
            Common.api.auth.Login({
                email: values.email,
                password: values.password,
            }),
        {
            onError: (err) => {
                console.log(err);
            },
            onSuccess: ({ data }) => {
                actions.handleLogin({
                    token: data?.result?.token || "",
                    id: data?.result?.id.toString() || "",
                });

                navigate(RoutesInstance.dashboard);
            },
        },
    );

    const handleSubmit = (values: IFormData) => {
        mutate(values);
    };

    const LoginSchema = Yup.object().shape({
        email: Yup.string()
            .email("پست الکترونیک وارد شده معتبر نمی باشد")
            .required("ورود شماره همراه یا نام کابری الزامی می باشد"),
        password: Yup.string()
            .min(6, "کلمه عبور باید بیشتر از 6 کاراکتر باشد")
            .max(32, "کلمه عبور باید کمتر از 32 کاراکتر باشد")
            .required("ورود کلمه عبور الزامی می باشد"),
    });

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleSubmit(values)}
            validationSchema={LoginSchema}
            validateOnMount={false}
            validateOnChange={!isFirstTime}
            validateOnBlur={!isFirstTime}
            validate={() => setIsFirstTime(false)}>
            {({
                values,
                errors,
                isValid,
                handleSubmit,
                handleChange,
                handleBlur,
            }) => (
                <Form onSubmit={handleSubmit}>
                    <div className="mb-6">
                        <Input.Wrapper
                            id="email"
                            label={"پست الکترونیک"}
                            required
                            error={errors.email}
                            classNames={{
                                error: "text-sm font-numeric",
                                label: "mb-2 text-gray-700 font-medium",
                            }}>
                            <Input
                                variant="filled"
                                color="blue"
                                radius={9999}
                                id="email"
                                name="email"
                                type="text"
                                placeholder="09120000000"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                classNames={{
                                    input: "shadow-md font-numeric text-left direction-ltr",
                                }}
                                disabled={isLoading}
                                value={values.email}
                                invalid={!!errors.email}
                            />
                        </Input.Wrapper>
                    </div>

                    <div className="mb-10">
                        <Input.Wrapper
                            id="password"
                            label="کلمه عبور"
                            required
                            error={errors.password}
                            classNames={{
                                error: "text-sm font-numeric",
                                label: "mb-2 text-gray-700 font-medium",
                            }}>
                            <Input
                                variant="filled"
                                color="blue"
                                radius={9999}
                                id="password"
                                name="password"
                                type="password"
                                placeholder="********"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                classNames={{
                                    input: "shadow-md text-left direction-ltr",
                                    invalid: "font-numeric",
                                }}
                                disabled={isLoading}
                                value={values.password}
                                invalid={!!errors.password}
                            />
                        </Input.Wrapper>
                    </div>

                    <div className="text-center mb-3">
                        <Button
                            variant="filled"
                            className="transition-all duration-300"
                            color="blue"
                            radius={9999}
                            fullWidth
                            type="submit"
                            disabled={!isValid || isLoading}
                            loading={isLoading}>
                            ورود
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default LoginContainer;
